var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHost = function SvgHost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.16 8.244a2.25 2.25 0 1 0-.342-.001 2.235 2.235 0 0 1-.835-.235c-1.125 1.829-2.79 2.324-4.238 2.334a2.25 2.25 0 1 0-.432 1.492c.366.017.752.01 1.149-.029 1.183-.118 2.496-.543 3.63-1.582.382-.35.728-.757 1.037-1.222.344.477.718.89 1.118 1.242a6.318 6.318 0 0 0 3.565 1.561c.303.032.598.043.881.037a2.248 2.248 0 0 0 1.807.909 2.25 2.25 0 1 0-2.244-2.415c-1.332-.07-2.865-.63-4.06-2.429a2.236 2.236 0 0 1-1.036.338ZM12 6.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm8.25 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-15.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.948 12.13c.366.347.847.574 1.38.614l-.069.227a.75.75 0 1 1-1.434-.442l.123-.4ZM12.75 18a.75.75 0 0 1 0 1.5H7.858a1.5 1.5 0 0 1-1.434-1.059l-1.753-5.697a2.242 2.242 0 0 0 1.38-.614L7.859 18h4.892Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 18a.75.75 0 0 0 0 1.5h4.892a1.5 1.5 0 0 0 1.434-1.059l1.753-5.697a2.241 2.241 0 0 1-1.38-.614L16.142 18H11.25Z"
  })));
};

export default SvgHost;